import { ReactElement } from "react";
import { localize } from "src/l10n";
import "./NotificationListHeader.scss";

interface IProps {
    /**
     * How many were unread when the list was opened.
     *
     * Opening the list marks everything read, so reading this from the store at
     * render time would always show zero. The caller captures it at the moment
     * the person opened the list and passes that.
     */
    unreadCount: number;
}

/**
 * "Notiser · 3 olästa". Sits above the notification list wherever the list is
 * shown next to the Just nu block, so the two sections can be told apart.
 */
function NotificationListHeader(props: IProps): ReactElement {
    const { unreadCount } = props;

    return (
        <div className="NotificationListHeader">
            <span className="NotificationListHeader-title">{localize("Notiser")}</span>

            {unreadCount > 0 && (
                <span className="NotificationListHeader-unread">
                    {`${unreadCount} ${localize("ATTENTION_UNREAD_SUFFIX")}`}
                </span>
            )}
        </div>
    );
}

export default NotificationListHeader;
